// extracted by mini-css-extract-plugin
export var content = "_dr-3";
export var list = "_dr-4";
export var settingsContent = "_dr-7";
export var settingsPanel = "_dr-8";
export var state = "_dr-6";
export var triggerBadge = "_dr-2";
export var triggerButton = "_dr-1";
export var triggerShell = "_dr-0";
export var unreadDot = "_dr-5";